// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tgW0a","colBig":"styles_colBig__1LCWo","colSmall":"styles_colSmall__Sh_8C"};